<template>
    <div class="video-box"
         @mouseenter.stop="handleSelect(item, $event)"
         @mouseleave.stop="handleOut($event)"
    >
        <!--video
            v-if="isShow"
            ref="video"
            class="video"
            preload="metadata"
            crossOrigin="anonymous"
            @mouseenter.stop="play"
            @mouseleave.stop="stop" >
            <source :src="newUrl">
        </video-->
        <img v-if="isShow" class="video" :src="newUrl+'?ci-process=snapshot&time=1&format=jpg&width=246&height=160'" />
        <span class="set-bg"
              @click.stop="onBackground"
        >
            <el-tooltip
                    class="item"
                    effect="light"
                    content="设为背景"
                    placement="left"
                    :open-delay="500"
            >
                <p class="imgs-box">
                  <img class="img" :src="$images.material.setBackground" alt="img" />
                  <img class="img active" :src="$images.material.setBackground1" alt="img" />
                </p>
            </el-tooltip>
        </span>
<!--        <p id="img" ref="img" class="img"></p>-->
        <!--<div class="txt-box">-->
            <!--<p class="name">{{item.alias || item.name}}</p>-->
        <!--</div>-->
    </div>
</template>

<script>
    import {getVideoFirstImg} from "../../../../../../../../../../utils/utils";

    export default {
        name: "video-box",
        props: {
            url: String,
            index: Number,
            item: Object
        },
        watch: {
            url(vl){
                this.newUrl = vl
                this.updateVideo()
            },
            newUrl(vl){this.$emit('update:url',vl)}
        },
        created() {
            this.$nextTick(()=>{
                // this.init()
            })
        },
        data(){
            return {
                isShow: true,
                newUrl: this.url.replace('https','http')
            }
        },
        methods: {
            init(){
                const eleVideos = document.querySelectorAll('.video-box .video')
                eleVideos[this.index].src = this.newUrl
                eleVideos[this.index].load()
                eleVideos[this.index].addEventListener('loadeddata', this.getImg)
            },
            // 刷新下视频
            updateVideo(){
                this.isShow = false
                const fn = setTimeout(()=>{
                    this.isShow = true
                    clearTimeout(fn)
                }, 300)
            },
            // 设为背景视频
            onBackground(){
                console.log('设为背景视频==>1')
                this.$emit('onBackground')
            },
            handleSelect(item,e){
                this.handleMouseEnterOpen();
                this.$emit('handleSelect', item, e)
            },
            handleOut(e){
                this.$emit('handleOut', e)
            },
            play(){
                this.$emit('play')
                // let video = this.$refs.video
                // // console.log('div==>play', this.$refs.video)
                // video.play()
            },
            stop(){
                this.$emit('stop')
                // let video = this.$refs.video
                // video.pause();
            },
            getImg(){
                const eleVideos = document.querySelectorAll('.video-box .video')
                const eleImgs = document.querySelectorAll('.video-box .img')
                console.log('ddd==>', eleVideos, eleImgs)
                getVideoFirstImg({
                    eleVideo: eleVideos[this.index],
                    eleTarget: eleImgs[this.index],
                    imgWidth:80,
                    imgHeight:80
                })
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        }
    }
</script>

<style lang="scss" scoped>
    .video-box{
        width: 100%;
        height: 80px;
        border-radius: 10px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        background: #f1f1f1;

        &:before{
            content: '';
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
        }

        .video{
            width: 100%;
            height: 100%;
            outline: none;
            transform: scale(1);
            transition: transform .3s ease;

            &:hover{
                transform: scale(1.2);
            }
        }

        .txt-box {
            position: absolute;
            width: 100%;
            /*height: 100%;*/
            bottom: 0px;
            left: 0px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .name {
                background: rgba(0, 0, 0, 0.25);
                font-size: 12px;
                padding: 4px;
                color: rgba(255, 255, 255, 0.85);
            }
        }

        .set-bg {
            position: absolute;
            bottom: 4px;
            right: 4px;
            width: 18px;
            height: 18px;
            font-size: 12px;
            color: #303133;
            transition: all .2s linear;

            .imgs-box {
                width: 100%;
                height: 100%;

                .img {
                    border-radius: 0px !important;

                    &.active {
                        display: none !important;
                    }
                }

                &:hover {
                    /*background-color: #e7622e;*/

                    .img {
                        display: none !important;

                        &.active {
                            display: inline-block !important;
                        }
                    }
                }
            }
        }
    }
</style>
